
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWifistrengt2Google as ObiWifistrengt2GoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wifistrengt-2-google.js';
 
 
 

 
 export const ObiWifistrengt2Google = createComponent({
   react: React,
   tagName: 'obi-wifistrengt-2-google',
   elementClass: ObiWifistrengt2GoogleElement,
   events: {
     
   }
  });
 
 